import { SagaIterator } from "redux-saga";
import { all, call, fork, put, select, takeEvery } from "redux-saga/effects";

import {
  fetchOptionsFailure,
  fetchOptionsRequest,
  fetchOptionsSuccess,
  updateOptionsFailure,
  updateOptionsRequest,
  updateOptionsSuccess,
} from "./actions";
import { FETCH_OPTIONS_TRIGGER, UPDATE_OPTIONS_TRIGGER } from "./constants";
import accountAPIService from "../../services/api/account";
import { getCustomerId, getIdTokenSubject } from "../../services/auth";
import {
  IFetchOptionsTriggerAction,
  IUpdateOptionsTriggerAction,
} from "./types";
import { selectETagHeader } from "./selectors";

export function* fetchOptions({
  payload: serviceCode,
}: IFetchOptionsTriggerAction): SagaIterator {
  try {
    yield put(fetchOptionsRequest());
    const params = {
      customerId: yield call(getCustomerId),
      principalId: yield call(getIdTokenSubject),
      serviceCode,
    };
    const response = yield call(
      [accountAPIService, accountAPIService.getOptions],
      params,
    );
    yield put(fetchOptionsSuccess(response));
  } catch (error) {
    yield put(fetchOptionsFailure(error));
  }
}

export function* updateOptions({
  payload: { serviceCode, limit, firewall },
  onSuccess,
  onError,
}: IUpdateOptionsTriggerAction): SagaIterator {
  try {
    yield put(updateOptionsRequest());

    const params = {
      customerId: yield call(getCustomerId),
      principalId: yield call(getIdTokenSubject),
      serviceCode: serviceCode,
      body: {
        max_visible_articles: limit,
        nat_firewall: firewall,
      },
      eTagHeader: yield select(selectETagHeader),
    };

    yield call([accountAPIService, accountAPIService.updateOptions], params);

    const response = yield call(
      [accountAPIService, accountAPIService.getOptions],
      params,
    );

    yield put(updateOptionsSuccess(response));
    yield call(onSuccess);
  } catch (error) {
    yield put(updateOptionsFailure(error));
    yield call(onError, error);
  }
}

export function* watchFetchOptions(): SagaIterator {
  yield takeEvery(FETCH_OPTIONS_TRIGGER, fetchOptions);
}

export function* watchUpdateOptions(): SagaIterator {
  yield takeEvery(UPDATE_OPTIONS_TRIGGER, updateOptions);
}

export function* accountSaga(): SagaIterator {
  yield all([fork(watchFetchOptions), fork(watchUpdateOptions)]);
}
